<template>
  <basic-container>
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
      label-="110px"
      margin-top="0"
      :rules="rules"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="小区名称" prop="areaName">
            <el-select
              v-model="form.areaName"
              filterable
              @change="getTreeNode(3, form.areaName)"
              style="width: 100%;"
              placeholder="请选择小区"
            >
              <el-option
                v-for="item in allPropertyList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="楼栋名称" prop="building">
            <el-select
              v-model="form.building"
              filterable
              @change="getTreeNode(4, form.building)"
              style="width: 100%;"
              placeholder="请选择楼栋"
            >
              <el-option
                v-for="item in buildingList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单元名称" prop="unitName">
            <el-select
              v-model="form.unitName"
              filterable
              @change="getTreeNode(6, form.unitName)"
              style="width: 100%;"
              placeholder="请选择单元"
            >
              <el-option
                v-for="item in unitList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="房间名称" prop="roomId">
            <el-select
              v-model="roomId"
              filterable
              @change="saveRoomId"
              style="width: 100%;"
              placeholder="请选择房间"
            >
              <el-option
                v-for="item in roomList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="扣款银行" prop="bankId">
            <el-select
              v-model="bankName"
              @change="bankChange"
              placeholder="请选择扣款银行"
              style="width: 100%;"
            >
              <el-option
                v-for="item in bankNameList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!--        <el-col :span="12">-->
        <!--          <el-form-item label="启用日期" prop="beginTime">-->
        <!--            <el-date-picker-->
        <!--              v-model="form.beginTime"-->
        <!--              type="date"-->
        <!--              placeholder="请选择启用日期"-->
        <!--              style="width: 100%;"-->
        <!--              :disabled="editDisable1"-->
        <!--              value-format="yyyy-MM-dd"-->
        <!--            ></el-date-picker>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <!--        <el-col :span="12">-->
        <!--          <el-form-item label="禁用日期" prop="unuseTime">-->
        <!--            <el-date-picker-->
        <!--              v-model="form.unuseTime"-->
        <!--              type="date"-->
        <!--              placeholder="请选择禁用日期"-->
        <!--              style="width: 100%;"-->
        <!--              :disabled="editDisable1"-->
        <!--              value-format="yyyy-MM-dd"-->
        <!--            ></el-date-picker>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col :span="24">
          <el-form-item label="扣款账户" prop="accountNo">
            <el-input v-model="form.accountNo" placeholder="请输入扣款账户"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="账户名称" prop="accountName">
            <el-input
              type="text"
              maxlength="30"
              v-model="form.accountName"
              placeholder="请输入账户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="账户备注" prop="accountRemark">
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.accountRemark"
              placeholder="请输入账户备注"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col></el-col>
      </el-row>
      <el-col offset="8">
        <el-form-item>
          <el-button type="primary" @click="onSubmit" style="width: 100px;">保存</el-button>
          <el-button type="danger" @click="closeDia" style="width: 100px;">退出</el-button>
        </el-form-item>
      </el-col>
    </el-form>
  </basic-container>
</template>
<script>
import { getLabelName, getPropertyTreeByObjectTypeKey } from '@/api/v4ward/itemset/feeitemset';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getbank,
} from '@/api/v4ward/bankaccount/basebankaccount';
import { getDictionary } from '../../../api/common';
import { getOptionNode } from '@/api/v4ward/property/baseproperty';
import SelectTree from '../../../components/vard-select-tree/vard-select-tree';
import { getTreeChildrenNode, getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';
export default {
  components: {
    SelectTree,
  },
  data() {
    return {
      unitPriceName: '单位价格(元)',
      bankNameList: [],
      bankName: '',
      objectTypeList: [],
      allPropertyList: [],
      buildingList: [],
      unitList: [],
      roomList: [],
      props: {
        value: 'id',
        label: 'title',
        children: 'children',
        // disabled:true
      },
      ////
      propertyName: '',
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      ////
      optionValue: '',
      feeSortList: [],
      feeTypeList: [],
      feeCycleList: [],
      feeCycleNameDisable: true,
      disableEnableDicData: [
        { label: '启用', value: 1 },
        { label: '禁用', value: 0 },
      ],
      gradePriceDisable: true,
      unitPriceDisable: true,
      gradePriceShow: false, //阶梯价格显示
      switchValue: { yes: 1, no: 0 },
      bank: [],
      form: {
        areaName: '',
        building: '',
        unitName: '',
        roomId: '',
        bankId: '',
        /* beginTime: '',
        unuseTime: '',*/
        accountNo: '',
        accountName: '',
        accountRemark: '',
      },
      rules: {
        //objectTypeId: [{ required: true, message: '请选择费项范围', trigger: 'change' }],
        areaName: [{ required: true, message: '请选择小区', trigger: 'change' }],
        building: [{ required: true, message: '请选择楼栋', trigger: 'change' }],
        unitName: [{ required: true, message: '请选择单元', trigger: 'change' }],
        roomId: [{ required: true, message: '请选择房间', trigger: 'change' }],
        bankId: [{ required: true, message: '请选择银行', trigger: 'change' }],
        /*   beginTime: [{ required: true, message: '请选择启用日期', trigger: 'change' }],
        unuseTime: [{ required: true, message: '请选择停用日期', trigger: 'change' }],*/
        accountNo: [
          {
            required: true,
            pattern: this.$validation.bankCard,
            message: '请输入正确的账户',
            trigger: 'change',
          },
        ],
        accountName: [{ required: true, message: '请输入账户名称', trigger: 'change' }],
      },
    };
  },
  created() {
    this.initPropertyList();
    getbank().then((res) => {
      this.bankNameList = res.data;
    });
  },
  mounted() {},
  methods: {
    saveRoomId(e) {
      this.$forceUpdate();
      this.form.roomId = e;
    },
    initPropertyList() {
      var that = this;
      getOptionNode({}).then((data) => {
        this.allPropertyList = data.data;
        this.allPropertyList[this.allPropertyList.length] = '全部';
      });
    },
    getTreeNode(type, id) {
      getTreeChildrenPowerNode({
        object_type: type,
        id: id,
      }).then((res) => {
        if (type == 3) {
          //楼栋下拉数据
          this.buildingList = res.data;
          this.unitList = [];
          this.roomList = [];
          this.form.building = '';
          this.form.unitName = '';
          this.form.roomId = '';
        } else if (type == 4) {
          //单元下拉数据
          this.unitList = res.data;
          this.form.unitName = '';
          this.form.roomId = '';
          this.roomList = [];
        } else if (type == 6) {
          //房间下拉数据
          this.form.roomId = '';
          this.roomList = res.data;
        } else {
          this.form.building = '';
          this.form.unitName = '';
          this.form.roomId = '';
        }
        this.$forceUpdate();
      });
    },
    bankChange(e) {
      this.form.bankId = e;
    },
    //获取银行名称
    initBankNameList: function () {
      getDictionary('bill_cutBank').then((data) => {
        this.bankNameList = data.data;
      });
    },
    clearData: function () {
      this.form = {
        roomId: '',
        bankId: '',
        /* beginTime: '',
        unuseTime: '',*/
        accountNo: '',
        accountName: '',
        accountRemark: '',
      };
      this.unitPriceName = '单位价格(元)';
      this.feeCycleNameDisable = true;
      this.gradePriceDisable = true;
      this.unitPriceDisable = true;
    },
    ////////////
    lazyLoadPropertyTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
        //this.isPropertyAddDialogInit = true;
        //this.propertyAddParentNodeTreeRoot = node;
        //this.propertyAddParentNodeTreeResolve = resolve;
      } else {
        id = node.data.id;
      }

      getTreeChildrenPowerNode({ id: id, power: 2 }).then(({ data }) => {
        resolve(data);
      });
    },
    propertyNodeTreeClick(node) {
      let nodeId = node[this.treeProps.value];
      let nodeTitle = node[this.treeProps.label];
      let nodeTypeName = node[this.treeProps.objectTypeName];
      this.propertyName = nodeTitle;
      this.form.roomId = nodeId;

      if (this.propertyAddShowDialogFlag) {
        this.$refs.propertyAddParentNodeSelectRef.blur();
        //this.propertyAddForm.parentId = nodeId;
        //this.propertyAddForm.parentObjectTypeName = nodeTypeName;
      }
    },
    ///////////////
    onPropertySelected: function (value) {
      if (value == null) {
      } else {
        var node = this.getTreeNode(value, this.propertyTreeList);
        if (node == null || node.objectType !== this.form.objectTypeId) {
          this.form.roomId = '';
          this.$refs.selectTree.valueTitle = '';
          //this.$refs.selectTree.clearHandle();
        } else {
          this.form.roomId = value;
          this.$refs.selectTree.valueTitle = node.title;
        }
      }
    },
    // getTreeNode: function (id, nodes) {
    //   var res;
    //   for (var i in nodes) {
    //     var node = nodes[i];
    //     if (node.id === id) {
    //       res = node;
    //     } else if (node.children) {
    //       var childFind = this.getTreeNode(id, node.children);
    //       if (typeof childFind !== 'undefined') {
    //         res = childFind;
    //       }
    //     }
    //   }
    //   return res;
    // },
    casecadeUpdateProperty: function () {
      if (this.form.roomId) {
        this.onPropertySelected(this.form.roomId);
      }
    },
    closeDia: function () {
      this.bankName = '';
      this.roomId = '';
      this.$refs['form'].resetFields();
      this.$emit('closeAddform');
    },
    // checkFormDataCorrect: function () {
    //   // 检查数据合法性
    //   var beginTime = Date.parse(this.form.beginTime);
    //   var unuseTime = Date.parse(this.form.unuseTime);
    //   var dateNow = new Date().getTime();
    //   console.log(0);
    //   if (!(beginTime < unuseTime)) {
    //     this.$message.error('禁用日期必须大于启用日期！');
    //     return false;
    //   }
    //   this.form.beginTime = this.appendSuffix(this.form.beginTime);
    //   this.form.unuseTime = this.appendSuffix(this.form.unuseTime);
    //   return true;
    // },
    appendSuffix(datetime) {
      if (datetime && datetime.length < 12) {
        return datetime + 'T00:00:00';
      } else {
        return datetime;
      }
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 检查数据合法性
          // var beginTime = Date.parse(this.form.beginTime);
          // var unuseTime = Date.parse(this.form.unuseTime);
          // console.log(0);
          // if (!(beginTime < unuseTime)) {
          //   this.$message.error('禁用日期必须大于启用日期！');
          //   return;
          // }
          add(this.form).then(() => {
            this.$message.success('操作成功!');
            // this.onLoad();
            //this.clearData();
            this.closeDia();
            // this.$emit('closeAeform');
          });
        } /*else {
          this.$message.warning('数据不合法！');
        }*/
      });
      /* .then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        error => {
          done();
          console.log(error);
        }
      );*/
    },
  },
};
</script>
<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}

.el-node-dialog-div {
  height: 400px;
  overflow: auto;
}

.el-property-dialog-div {
  height: 500px;
  overflow: auto;
}
</style>
